import styles from './index.module.scss'
const Bottom = () => {
  return (
    <div className={styles.box}>
      <a href='https://beian.miit.gov.cn' target='__blank'>京ICP备2022028232号</a> ©2022 by MetaHub. All rights reserved 
    </div>
  )
}

export default Bottom